import { Scrollbar } from '../core'
import Locator from './locator'

const favorites = {
  id: undefined,
  items: undefined,

  stringRandom(length) {
    const characters = 'abdefil012345679'
    let result = ''
    const charactersLength = characters.length
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  },

  generateFavoritesUid() {
    let string = ''
    while (string.length < 32) {
      string += this.stringRandom(Math.floor(Math.random() * (16 - 4 + 1)) + 4)
      string += '-'
    }
    string = string.slice(0, -1)
    if (string.length < 32) {
      string += this.stringRandom(1)
    }
    return string.substring(0, 32).toLowerCase()
  },

  add(content_uid, response) {
    if (!this.items.includes(content_uid)) {
      this.items.push(content_uid);
      localStorage.setItem('favorites_items', JSON.stringify(this.items))
    }
    response = $('<div>').append(response)
    if (response.find('[class*="card-"]').length) {
      let sidebar = $.mlmi.favorites.sidebar()
      if (sidebar.is_loaded) {
        sidebar.addCard(response.find('[class*="card-"]:first'), true)
      }
    }
  },

  remove(content_uid) {
    this.items = this.items.filter(item => item !== content_uid);
    localStorage.setItem('favorites_items', JSON.stringify(this.items))
  },

  has(content_uid) {
    return this.items.includes(content_uid)
  },

  buttons(scope) {
    if (scope == undefined) {
      scope = document
    }
    $(scope).find('button.favorite__toggle').each(function() {
      $(this).FavoriteButton()
    })
  },

  sidebar() {
    if ($('.header__favorites').length) {
      return $('.header__favorites').FavoritesSidebar()
    }
  },

  page() {
    if ($('.page-favoris').length) {
      $('.page-favoris .favorites-list').FavoritesPage()
    }
  },

  init() {
    if ('localStorage' in window) {
      this.id = localStorage.getItem('favorites_id')
      this.items = localStorage.getItem('favorites_items')
      if (!this.id) {
        this.id = this.generateFavoritesUid()
        this.items = []
        localStorage.setItem('favorites_id', this.id)
        localStorage.setItem('favorites_items', JSON.stringify(this.items))
      } else if (!this.items) {
        this.items = []
      } else {
        this.items = JSON.parse(this.items)
      }
    }
    $.mlmi.favorites = this
    this.sidebar()
    this.buttons()
    this.page()
  },
}

$.fn.FavoriteButton = function() {
  let self = this

  if (self.data('favorite-button')) {
    return self.data('favorite-button');
  }

  self.pressed = self.attr('aria-pressed') === 'true'
  self.uid = self.data('content-uid')

  self.add = function() {
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'add',
        'list_uid': $.mlmi.favorites.id,
        'content_uid': self.uid,
      },
      success: function(response) {
        $.mlmi.favorites.add(self.uid, response)
      },
      error: function(error) {
        self.toggle_off()
      },
    })
  }

  self.remove = function() {
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'remove',
        'list_uid': $.mlmi.favorites.id,
        'content_uid': self.uid,
      },
      success: function(response) {
        $.mlmi.favorites.remove(self.uid)
      },
      error: function(error) {
        self.toggle_on()
      },
    })
  }

  self.toggle_on = function() {
    self.pressed = true
    self.attr('aria-pressed', 'true')
  }

  self.toggle_off = function() {
    self.pressed = false
    self.attr('aria-pressed', 'false')
  }

  self.clicked = function(e) {
    e.preventDefault()
    e.stopPropagation()

    if (self.pressed) {
      self.toggle_off()
      self.remove()
      $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_off()
    } else {
      self.toggle_on()
      self.add()
      $('body').find('button.favorite__toggle[data-content-uid="' + self.uid + '"]').not(self).FavoriteButton().toggle_on()
    }
  }

  return function() {
    self.on('click', self.clicked)
    if ($.mlmi.favorites.has(self.uid)) {
      self.toggle_on()
    } else {
      self.toggle_off()
    }
    self.data('favorite-button', self)
    return self
  }()
}

$.fn.FavoritesPage = function() {
  let self = this

  self.is_shared_list = self.data('list-id') ? true : false
  self.is_locator_initialized = false

  self.copy_link = function(e) {
    e.preventDefault()
    let target = $(this)
    self.original_text = target.find('span').html()
    let textarea = $('<textarea>')
    textarea.val(target.attr('href'))
    target.append(textarea)
    textarea.focus().select()
    document.execCommand("Copy")
    textarea.remove()
    target.find('span').html(bassaintlaurent_l10n.COPIED_LINK);
    setTimeout(function() {
      target.find('span').html(self.original_text);
    }, 3200)
    return false;
  }

  return function() {
    /* Favorites list */
    if (!self.is_shared_list) {
      self.attr('data-list-id', $.mlmi.favorites.id)
      $('.share-favorites').attr('href', $('.share-favorites').attr('href') + $.mlmi.favorites.id + '/')
      $('.share-favorites').removeClass('d-none').on('click', self.copy_link)
    }

    /* Load items */
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_page',
        'language': bassaintlaurent_l10n.LANGUAGE,
        'items': self.is_shared_list ? 0 : $.mlmi.favorites.items,
        'list': self.is_shared_list ? self.data('list-id') : 0,
      },
      success: function(response) {
        response = $('<div>').append(response)
        let favoritesCount = 0

        /* Attraits */
        if (!response.find('.card--type-location').length) {
          $('.favorites--type-location').remove()
        }
        response.find('.card-location.card--type-location').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-location .grid--style--default').append(gridItem)
          favoritesCount++
        })
        response.find('.card-text.card--type-location').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-location .grid--style--text').append(gridItem)
        })

        /* Regroupements */
        if (!response.find('.card--type-grouping').length) {
          $('.favorites--type-grouping').remove()
        }
        response.find('.card-location.card--type-grouping').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-grouping .grid--style--default').append(gridItem)
          favoritesCount++
        })
        response.find('.card-text.card--type-grouping').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-grouping .grid--style--text').append(gridItem)
        })

        /* Municipalités */
        if (!response.find('.card--type-municipality').length) {
          $('.favorites--type-municipality').remove()
        }
        response.find('.card-municipality.card--type-municipality').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-municipality .grid--style--default').append(gridItem)
          favoritesCount++
        })
        response.find('.card-text.card--type-municipality').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-municipality .grid--style--text').append(gridItem)
        })

        /* Événements */
        if (!response.find('.card--type-event').length) {
          $('.favorites--type-event').remove()
        }
        response.find('.card-location.card--type-event').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-event .grid--style--default').append(gridItem)
          favoritesCount++
        })
        response.find('.card-text.card--type-event').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-event .grid--style--text').append(gridItem)
        })

        /* Articles */
        if (!response.find('.card--type-article').length) {
          $('.favorites--type-article').remove()
        }
        response.find('.card--type-article').each(function() {
          let gridItem = $('<div>').addClass('grid__item').append($(this))
          $('.favorites--type-article .grid').append(gridItem)
          favoritesCount++
        })

        /* Map locations */
        if (favoritesCount && response.find('.favorite-locations').length) {
          $('.favorite-locations').replaceWith(response.find('.favorite-locations'))
        }

        /* Show interface */
        if (favoritesCount) {
          if ('locations' in window && window.locations.length > 0) {
            $('.favorites-tabs').show().on('tab_changed', function(event, current) {
              if (current.name == 'vue-en-grille' && 'locations' in window && window.locations.length > 0) {
                if (!self.is_locator_initialized) {
                  self.is_locator_initialized = true
                  Locator.init($('.favorites-list'))
                }
              }
            })
          } else {
            $('.favorite-tabs').hide()
          }
          $('.favorite-articles').show()
        } else {
          $('.no-favorites').show()
        }

        /* Favorite buttons */
        favorites.buttons(self)

        /* Fancybox fiches */
        $.mlmi.Fiches_Init()
      },
      error: function(error) {
        console.log('Erreur', error)
      },
    })
    return self
  }()
}

$.fn.FavoritesSidebar = function() {
  let self = this

  if (self.data('favorites-sidebar')) {
    return self.data('favorites-sidebar')
  }

  self.is_loaded = false
  self.scrollbar = undefined

  self.populate = function() {
    /* Load items */
    $.ajax({
      url: '/favorites/',
      method: 'POST',
      data: {
        'action': 'get_page',
        'language': bassaintlaurent_l10n.LANGUAGE,
        'items': self.is_shared_list ? 0 : $.mlmi.favorites.items,
        'list': self.is_shared_list ? self.data('list-id') : 0,
      },
      success: function(response) {
        response = $('<div>').append(response)
        self.is_loaded = true
        let favoritesCount = 0

        response.find('.card-location.card--type-event, .card-location.card--type-location, .card-article.card--type-article, .card-municipality.card--type-municipality').each(function() {
          self.addCard($(this))
          favoritesCount++
        })

        if (!favoritesCount && response.find('.no-favorites').length) {
          self.find('.header__favorites__content').append(response.find('.no-favorites .text-content').addClass('bg-dark-blue'))
        }

        /* Favorite buttons */
        favorites.buttons(self)

        /* Fancybox fiches */
        $.mlmi.Fiches_Init(self)

        /* Update scrollbar */
        self.scrollbar.update()
      },
      error: function(error) {
        console.log('Erreur', error)
      },
    })
  }

  self.addCard = function(card, prepend) {
    if (prepend == undefined) {
      prepend = false
    }
    if (self.find('.favorite__toggle[data-content-uid="' + card.find('.favorite__toggle').attr('data-content-uid') + '"]').length) {
      return
    }
    let gridItem = $('<div>').addClass('grid__item').append(card)
    if (prepend) {
      self.find('.grid--style--sidebar').prepend(gridItem)
    } else {
      self.find('.grid--style--sidebar').append(gridItem)
    }

    /* Remove no favorites message */
    self.find('.header__favorites__content .text-content').remove()

    /* Favorite buttons */
    favorites.buttons(self)

    /* Fancybox fiches */
    $.mlmi.Fiches_Init(self)

    /* Update scrollbar */
    self.scrollbar.update()
  }

  self.click_outside = function(e) {
    if (!$('body').hasClass('fancybox-active') && $('body').hasClass('--favorites-open') && !$(e.target).hasClass('header__favorites') && !$(e.target).closest('.header__favorites').length) {
      self.close()
    }
  }

  self.close = function() {
    $('body').removeClass('--favorites-open')
    $(window).off('click', self.click_outside)
  }

  self.open = function() {
    $('body').addClass('--favorites-open')
    requestAnimationFrame(function() {
      $(window).off('click', self.click_outside).on('click', self.click_outside)
    })
  }

  self.initialize = function() {
    $('.header__fixed-links__favorites, .header__favorites__close-btn').on('click', function(e) {
      e.preventDefault()
      if ($('body').hasClass('--favorites-open')) {
        self.close()
      } else {
        if (!self.is_loaded) self.populate()
        self.open()
        if (self.scrollbar == undefined) {
          self.scrollbar = new Scrollbar(self.find('.header__favorites__list'), {
            direction: 'vertical',
            desktop: true,
            mobile: true,
          })
        }
      }
    })
  }

  return function() {
    self.initialize()
    self.data('favorites-sidebar', self)
    return self
  }()
}

export default favorites
